module.exports = __webpack_public_path__ + "static/media/149-czech-republic.27fe1976.svg";